import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

import { translate } from 'services/i18nService';

import fanClubIcon from '../../../../../../images/icon-fanclub.png';

import styles from './index.css';


const tooltipClasses = {
  tooltip: styles.tooltipWrapper,
  arrow: styles.arrowWrapper,
};

const FanclubPrice = (props) => {
  const {
    discountedFanclubPrice,
    fanclubPrice,
    performerName,
  } = props;

  const discountedPriceElement = useMemo(() => {
    if (!discountedFanclubPrice) {
      return null;
    }

    return (
      <span>
        {' '}{discountedFanclubPrice}
      </span>
    );
  }, [discountedFanclubPrice]);

  if (!fanclubPrice) {
    return null;
  }

  let title = undefined;
  let priceText = undefined;
  if (fanclubPrice > 0) {
    title = translate(
      'v2profile.fanclub.special.price.tooltip',
      { 0: `<strong>${performerName}</strong>` }
    );

    priceText = fanclubPrice;
  } else {
    title = translate(
      'v2profile.fanclub.free.tooltip',
      { 0: `<strong>${performerName}</strong>` }
    );

    priceText = translate('profile.profile.videos.free');
  }

  const priceTextClases = classNames({
    [styles.priceText]: true,
    [styles.lineThrough]: discountedFanclubPrice,
  });

  return (
    <Tooltip
      arrow={true}
      classes={tooltipClasses}
      enterTouchDelay={10}
      leaveTouchDelay={3000}
      placement="bottom-start"
      title={title}
    >
      <div className={styles.fanclubPrice}>
        <img
          alt="star"
          className={styles.fanclubIcon}
          src={fanClubIcon}
        />
        <span className={priceTextClases}>
          {priceText}
        </span>
        {discountedPriceElement}
      </div>
    </Tooltip>
  );
};

FanclubPrice.propTypes = {
  discountedFanclubPrice: PropTypes.number.isRequired,
  fanclubPrice: PropTypes.number.isRequired,
  performerName: PropTypes.string.isRequired,
};

export default memo(FanclubPrice);
